import styled from 'styled-components';
import { Box } from '@material-ui/core';

const Container = styled(Box)`
  background-color: var(--color-white);
  border-radius: var(--border-radius-02);
  box-shadow: var(--box-shadow-06);
`;

export const Styled = {
  Container,
};
